// store.js
import Vue from 'vue';
import Vuex from 'vuex';
 
Vue.use(Vuex);
 
export default new Vuex.Store({
  state: {
    userRole: localStorage.getItem('user_role') || ''
  },
  mutations: {
    SET_USER_ROLE(state, role) {
      state.userRole = role;
      localStorage.setItem('user_role', role);
    },
    CLEAR_USER_ROLE(state) {
      state.userRole = '';
      localStorage.removeItem('user_role');
    }
  },
  actions: {
    // 异步操作和逻辑
    setUserRole({ commit }, role) {
      commit('SET_USER_ROLE', role);
    },
    clearUserRole({ commit }) {
      commit('CLEAR_USER_ROLE');
    }
  },
  getters: {
    // 计算派生状态
    isAdmin: state => state.userRole === 'admin',
    isUser: state => state.userRole === 'user',
    userRole: state => state.userRole
  }
});


// WEBPACK FOOTER //
// ./src/store/index.js